<template>
  <div
    v-if="showIndicators"
    class="c-epg-indicators"
  >
    <div
      v-if="props.showLiveIndicator && isLive"
      class="c-epg-indicators__live"
    >
      {{ $t('common.live') }}
    </div>
    <ui-epg-upsell-indicator
      v-if="isUpsell"
      :show-tooltip="props.showTooltip"
    ></ui-epg-upsell-indicator>
  </div>
</template>
<script setup>
  import { computed } from 'vue';
  import UiEpgUpsellIndicator from './epg-upsell-indicator.vue';

  const props = defineProps({
    program: Object,
    channel: Object,
    showLiveIndicator: Boolean,
    showTooltip: Boolean,
  });

  const isLive = computed(() => props.program?.liveProgramme && !props.channel?.liveProgrammeIndicatorDisabled);
  const isUpsell = computed(() => props.program?.upsellToGo3 || props.channel?.upsellToGo3);
  const showIndicators = computed(() => (props.showLiveIndicator && isLive) || isUpsell);
</script>
